<template>
  <div>
    <el-card shadow="never"
             class="aui-card--fill">
      <div class="btn-left">
        <!-- 生成账号 -->
        <el-button class="el-button-columnBtn"
                   @click="buildHandle()"
                   plain>{{ $t('user.generateAccount') }}</el-button>
                   <!-- 下载模板 -->
        <el-button class="el-button-columnBtn"
                   plain
                   @click="upload">{{ $t('user.downloadtemplate') }}</el-button>
                   <!-- 批量删除 -->
        <el-button class="el-button-columnBtn"
                   plain
                   v-if="$hasPermission('sys:commuserimport:delete')"
                   @click="deleteHandle()"
                   :disabled="dataListSelections.length <= 0">{{ $t('user.batchdeletion') }}</el-button>
      </div>
      <div class="table">
        <el-table border
                  :data="dataList"
                  @selection-change="selectionChangeHandle">
          <el-table-column type="selection"
                           header-align="center"
                           align="center"
                           width="50">
          </el-table-column>
          <!-- 姓名 -->
          <el-table-column  prop="userName"
                           :label="$t('user.name')"
                           width="130"
                           align="center">
          </el-table-column>
          <el-table-column prop="firstName"
                           label="FirstName"
                           width="100"
                           align="center">
          </el-table-column>
          <el-table-column prop="lastName"
                           label="LastName"
                           width="100"
                           align="center">
          </el-table-column>
          <!-- 性别 -->
          <el-table-column prop="sexCode"
                           :label="$t('user.gender')"
                           width="100"
                           align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.sexCode == '10'">{{$t('user.gender0')}}</span>
            <!-- 未活动 -->
            <span v-if="scope.row.sexCode == '20'">{{$t('user.gender1')}}</span>
          </template>
          </el-table-column>
          <!-- 组织类型 -->
          <el-table-column prop="orgType"
                           :label="$t('organization.orgType')"
                           :formatter="orgFormatter"
                           width="120"
                           align="center">
          </el-table-column>
          <!-- 证件类型 -->
          <el-table-column prop="idcard"
                           :label="$t('user.idtype')"
                           width="120"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.idType == '10'">{{$t('user.idcard')}}</span>
              <span v-if="scope.row.idType == '20'">{{$t('user.passport')}}</span>
            </template>
          </el-table-column>
          <!-- 身份证 -->
          <el-table-column prop="idcard"
                           :label="$t('user.idcard')"
                           width="250"
                           align="center">
          </el-table-column>
          <!-- 手机号 -->
          <el-table-column prop="mobile"
                           :label="$t('user.mobile')"
                           width="200"
                           align="center">
          </el-table-column>
          <!-- 岗位 -->
          <el-table-column prop="jobCode"
                           :label="$t('user.userpost')"
                           width="130"
                           align="center">
          </el-table-column>
          <el-table-column prop="accountStatus"
                           :label="$t('user.doingcounts')"
                           width="130"
                           align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.accountStatus === '10'">{{$t('user.doing')}}</span>
            <span v-if="scope.row.accountStatus === '20'">{{$t('user.nodoing')}}</span>
            <span v-if="scope.row.accountStatus === ''">{{$t('user.nodoing1')}}</span>
          </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="pageSizeChangeHandle"
                       @current-change="pageCurrentChangeHandle"
                       :current-page="page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="limit"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </el-card>
    <import-excel v-if="importExcelVisible"
                  url="/sys/commuser/import"
                  shuttering="/sys/commuser/import_mould"
                  :name="$t('user.userImporttemplate')"
                  ref="importExcel"
                  @refreshDataList="getDataList"></import-excel>
  </div>
</template>

<script>
import Vue from 'vue'
import ImportExcel from '@/components/upload/import-excel'
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  data () {
    let _this = this
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/commuserimport/list',
        getDataListIsPage: true
      },
      importExcelVisible: false,
      tableData: [],
      dataListLoading: false,
      dataListSelections: [],
      // 组织类型
      userorgType: _this.enums['orgType'],
      dataList: [],
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4
    }
  },
  components: {
    ImportExcel
  },
  methods: {
    orgFormatter (row) {
      // 组织类型
      return Vue.filter('coverEnum')(row.orgType, 'userType')
    },
    // 下载模板批量导入
    upload () {
      this.importExcelVisible = true
      this.$nextTick(() => {
        this.$refs.importExcel.init()
      })
    },
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 删除
    deleteHandle (id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.importUserId
      })
      this.$confirm(this.$t('user.delet'), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$request.delete(`/sys/commuserimport/delete`,
          { 'ids': ids }
        ).then(() => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.getDataList()
            }
          })
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 生成账号
    buildHandle (id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.importUserId
      })
      console.warn(ids)
      if (ids !== '' && ids !== null && ids.length !== 0) {
        this.$request.delete(`/sys/commuserimport/generateUser`,
          { 'ids': ids }
        ).then(() => {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.getDataList()
            }
          })
        })
      } else {
        this.$alert(this.$t('user.placeselect'), this.$t('prompt.title')).then((res) => {
          console.log(res)
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }
}
</script>
<style type="text/css" scoped>
</style>
